import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'ghost' | 'icon' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
}

const variantStyles: Record<string, string> = {
  primary:
    'inline-flex items-center justify-center gap-2 bg-brand text-white font-medium rounded-btn hover:bg-brand-hover active:scale-[0.98] disabled:bg-slate-400 disabled:cursor-not-allowed transition-all',
  secondary:
    'inline-flex items-center justify-center gap-2 bg-white text-brand border-2 border-brand font-medium rounded-btn hover:bg-brand-bg active:scale-[0.98] disabled:bg-slate-100 disabled:text-slate-400 disabled:border-slate-300 disabled:cursor-not-allowed transition-all',
  ghost:
    'bg-transparent hover:bg-gray-100 min-h-0 transition-colors',
  icon:
    'w-[2.5rem] h-[2.5rem] min-h-[2.5rem] p-1 bg-white hover:bg-gray-100 border border-border-default rounded-md transition-colors flex items-center justify-center',
  outline:
    'inline-flex items-center justify-center gap-2 bg-white text-text-dark border border-brand font-semibold rounded-btn hover:bg-brand hover:text-white active:scale-[0.98] transition-all',
};

const sizeStyles: Record<string, string> = {
  sm: 'h-btn-sm text-body px-4',
  md: 'h-btn text-body-lg px-6',
  lg: 'h-[3.5rem] text-body-lg px-6',
};

const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  className = '',
  children,
  ...rest
}) => {
  const baseStyles = variantStyles[variant] || variantStyles.primary;
  const sizeStyle = variant === 'icon' || variant === 'ghost' ? '' : sizeStyles[size] || sizeStyles.md;
  const widthStyle = fullWidth ? 'w-full' : '';

  return (
    <button
      className={`${baseStyles} ${sizeStyle} ${widthStyle} ${className}`.trim()}
      {...rest}
    >
      {children}
    </button>
  );
};

export default Button;
